import React from "react";
import { Tooltip } from "antd";
import SmartIcon from "../../../components/generic/genericIcon/SmartIcon";
import { RoleToLinkMapper } from "../../utils/UrlUtils";
import { useNavigate } from "react-router";
import { useGetRole } from "../../generic/hooks/useGetRole";
import { Space } from "antd";

const FormSummaryAction = ({ formData }) => {
  const role = useGetRole();
  const navigate = useNavigate();

  const handleFormView = async () => {
    const form = JSON.parse(formData?.formIdentifier || "{}");
    navigate(
      `${RoleToLinkMapper(role)}form-viewer?templateCode=${
        form[0]?.templateCode
      }&patientIdentifier=${
        formData?.patient?.userIdentifier
      }&workforceIdentifier=${
        formData?.workforce?.userIdentifier
      }&formIdentifier=${
        form[0]?.formIdentifier
      }&readOnly=${true}&opportunityId=${formData?.opportunityId}&taskId=${
        formData?.taskId
      }&formSummary=${true}`
    );
  };

  return (
    <Space>
      <Tooltip title="View Form" placement="bottom">
        <>
          <SmartIcon iconKey="report" handleIconClick={handleFormView} />
        </>
      </Tooltip>
    </Space>
  );
};

export default FormSummaryAction;
